
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.58203 0C8.17063 0 8.66916 0.387802 8.83496 0.921875L13.0781 2.19531C13.3163 1.86665 13.7027 1.65242 14.1396 1.65234C14.8638 1.65234 15.4512 2.23973 15.4512 2.96387C15.4511 3.17829 15.398 3.37991 15.3066 3.55859L17.1807 8.02246C17.6606 8.21722 18 8.68744 18 9.2373C17.9998 9.86073 17.5637 10.3808 16.9805 10.5137L15.1904 13.9072C15.3533 14.1257 15.4512 14.396 15.4512 14.6895C15.451 15.4134 14.8637 16 14.1396 16C13.6247 15.9999 13.1802 15.7026 12.9658 15.2705H2.14453C1.91808 15.4569 1.62772 15.5684 1.31152 15.5684C0.587569 15.5683 0.000197728 14.9817 0 14.2578C0 13.7541 0.284504 13.3163 0.701172 13.0967V5.74707C0.329648 5.51568 0.0811831 5.10563 0.0810547 4.63574C0.0810547 3.91161 0.668446 3.32422 1.39258 3.32422C1.60763 3.3243 1.8102 3.37691 1.98926 3.46875L6.28418 1.13086C6.37206 0.492199 6.91926 0.000178143 7.58203 0ZM8.52734 2.21777C8.28873 2.46641 7.95386 2.62207 7.58203 2.62207C7.2892 2.62199 7.01996 2.52462 6.80176 2.3623L2.7002 4.5957C2.70059 4.6089 2.70312 4.62245 2.70312 4.63574C2.70299 5.12727 2.43159 5.55396 2.03125 5.77832V13.1611C2.30248 13.3395 2.50145 13.6165 2.58203 13.9404H13.0645C13.2689 13.6473 13.5895 13.4425 13.96 13.3916L15.6982 10.0947C15.4989 9.86479 15.377 9.56552 15.377 9.2373C15.377 8.841 15.5532 8.48554 15.8311 8.24512L14.1631 4.27246C14.1554 4.27259 14.1474 4.27441 14.1396 4.27441C13.627 4.27432 13.1842 3.97966 12.9688 3.55078L8.52734 2.21777Z","fill":"currentColor"}})])
          )
        }
      }
    